import React from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Patients from "../pages/Patients/Patients";
import PatientDetails from "../pages/Patients/PatientDetails";
import FollowUps from "../pages/Follow-ups/FollowUps";
import Appointments from "../pages/Appointments/Appointments";
import AppointmentDetails from "../pages/Appointments/AppointmentDetails";
import Prescriptions from "../pages/Prescriptions/Prescriptions";
import Messages from "../pages/Messages/Messages";
import Profile from "../pages/Profile/Profile";
import QuestionnaireReview from "../pages/Follow-ups/QuestionnaireReview";
import AppointmentBooking from "../pages/Appointments/AppointmentBooking";
import Notifications from "../pages/Notification";
import VideoCall from "../components/VideoCall";
import Availability from "../pages/Profile/Availablity";
import Plans from "../pages/Plans/Plans";

// import Error404 from './pages/Error404';

const ContentRoutes = () => (
  <Routes>
    {/* Default redirect to dashboard */}
    {/* <Route index element={<Navigate to="dashboard" replace />} /> */}

    {/* Dashboard Route */}
    <Route path="/" element={<Dashboard />} />
    <Route path="notifications" element={<Notifications />} />
    <Route path="patients" element={<Patients />} />
    <Route path="patients/:id" element={<PatientDetails />} />
    <Route path="follow-ups" element={<FollowUps />} />
    <Route
      path="follow-ups/questionnaire/:id"
      element={<QuestionnaireReview />}
    />
    <Route path="appointments" element={<Appointments />} />
    <Route path="appointments/:id" element={<AppointmentDetails />} />
    <Route path="/appointments/create" element={<AppointmentBooking />} />
    <Route
      path="/appointments/reschedule/:id"
      element={<AppointmentBooking />}
    />
    <Route path="video-call/:appointmentId" element={<VideoCall />} />
    <Route path="prescriptions" element={<Prescriptions />} />
    <Route path="messages" element={<Messages />} />
    <Route path="profile" element={<Profile />} />
    <Route path="profile/availability" element={<Availability />} />
    <Route path="plans" element={<Plans />} />

    {/* 404 Route - must be last */}
    {/* <Route path="*" element={<Error404 />} /> */}
    <Route
      path="*"
      element={<div className="text-center p-8">404 - Page Not Found</div>}
    />
  </Routes>
);

export default ContentRoutes;
